/* global axios */
import ApiClient from './ApiClient';

const buildFormData = (scope, values, files, mentionedUserIds) => {
  const payload = new FormData();
  Object.entries(values).forEach(([key, value]) => {
    payload.append(`${scope}[${key}]`, value ?? '');
  });
  files.forEach(file => payload.append(`${scope}[attachments][]`, file));
  mentionedUserIds.forEach(id =>
    payload.append(`${scope}[mentioned_user_ids][]`, id)
  );
  return payload;
};

class TalkviaForumAPI extends ApiClient {
  constructor() {
    super('talkvia_forum', { accountScoped: true });
  }

  overview() {
    return axios.get(this.url);
  }

  topics(params = {}) {
    return axios.get(`${this.url}/topics`, { params });
  }

  topic(id) {
    return axios.get(`${this.url}/topics/${id}`);
  }

  mentionableUsers(q = '') {
    return axios.get(`${this.url}/mentionable_users`, { params: { q } });
  }

  createTopic(topic, files = [], mentionedUserIds = []) {
    const payload = buildFormData('topic', topic, files, mentionedUserIds);
    return axios.post(`${this.url}/topics`, payload);
  }

  updateTopic(id, topic) {
    return axios.patch(`${this.url}/topics/${id}`, { topic });
  }

  deleteTopic(id) {
    return axios.delete(`${this.url}/topics/${id}`);
  }

  createPost(
    topicId,
    body,
    files = [],
    mentionedUserIds = [],
    replyToId = null
  ) {
    const values = replyToId ? { body, reply_to_id: replyToId } : { body };
    const payload = buildFormData('post', values, files, mentionedUserIds);
    return axios.post(`${this.url}/topics/${topicId}/posts`, payload);
  }

  updatePost(postId, body) {
    return axios.patch(`${this.url}/posts/${postId}`, { body });
  }

  deletePost(postId) {
    return axios.delete(`${this.url}/posts/${postId}`);
  }

  setLike(postId, liked) {
    return axios[liked ? 'delete' : 'post'](`${this.url}/posts/${postId}/like`);
  }

  acceptSolution(topicId, postId) {
    return axios.post(`${this.url}/topics/${topicId}/solution/${postId}`);
  }

  setSubscription(topicId, subscribed) {
    return axios[subscribed ? 'delete' : 'post'](
      `${this.url}/topics/${topicId}/subscription`
    );
  }

  report(payload) {
    return axios.post(`${this.url}/reports`, payload);
  }
}

export default new TalkviaForumAPI();
